import { render, staticRenderFns } from "./InventoryTableForUser.vue?vue&type=template&id=21f3f910&scoped=true"
import script from "./InventoryTableForUser.vue?vue&type=script&lang=js"
export * from "./InventoryTableForUser.vue?vue&type=script&lang=js"
import style0 from "./InventoryTableForUser.vue?vue&type=style&index=0&id=21f3f910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3f910",
  null
  
)

export default component.exports